module.exports = __webpack_public_path__ + "assets/812e84f41847098bde5916b503f739aa.png";